<template>
  <div class="kd-course-gallery__card-holder">
    <div class="kd-card--course-card__discount-container" v-if="showFree">
      <span class="kd-card--course-card__discount-amount">
        <del>{{program.discount}}</del> FREE!
      </span>
    </div>
    <div class="kd-card--course-card__discount-container" v-else-if="!showFree && showDiscount">
      <span class="kd-card--course-card__discount-amount">
        {{program.discount}} OFF!
      </span>
    </div>

    <a class="kd-card kd-card--carousel-card h365p kd-card--responsive">
      <img :src="programLogoUrl" class="kd-card__img img-responsive">

      <header class="kd-card__info">
        <div class="kd-card__info_icon">
          <i class="kf kf-programs-icon"></i>
        </div>

        <div class="kd-card__info_item-title">{{program.title}}</div>
        <div class="kd-card__info_school">{{program.institution_name}}</div>
        <div class="kd-card__info_count">{{program.num_courses}}</div>

        <a
          :href="program_path"
          class="kd-btn kd-btn--md btn--outline"
          tabindex="-1"
          data-skip-pjax="true"
        >
          <span>
            {{I18n.t('dict.view_this', { name: I18n.t('dict.program') })}}
          </span>
        </a>
      </header>
    </a>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "programCard",

  data() {
    return {
      program_path: this.program.url
    }
  },

  props: ['program'],

  computed: {
    programLogoUrl() {
      return this.program.card_image;
    },

    showDiscount() {
      return this.program.discount;
    },
    showFree(){
      return this.program.free;
    }
  },
}
</script>
